import '.ae{flex-shrink:0;}.ssr-plugin'
import '.aj{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ai{height:100%;}.ssr-plugin'
import '.by{border:none;}.ssr-plugin'
import '.cv{background-color:transparent;}.ssr-plugin'
import '.cw{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.be{position:sticky;}.ssr-plugin'
import '.cx{top:4rem;}.ssr-plugin'
import '.cy{z-index:7;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.cz{padding-bottom:1rem;}.ssr-plugin'
import '.d0{margin-bottom:1rem;}.ssr-plugin'
import '.d1{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.bf{top:0px;}.ssr-plugin'
import '.bk{left:0px;}.ssr-plugin'
import '.bl{right:0px;}.ssr-plugin'
import '.bm{bottom:0px;}.ssr-plugin'
import '.d2{z-index:9999;}.ssr-plugin'
import '.d3{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.bd{justify-content:flex-end;}.ssr-plugin'
import '.ak{flex:1;}.ssr-plugin'
import '.bv{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="ae aj n ai by cv cw"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e r"
    >
      <div className="be cx cy v cz d0 d1 d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i bf bk bl bm d2 v d3 d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="aj d bd d1"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="ak bv">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
